import"./ProductBundles.css.ts.vanilla.css";var r="_1m5jtrj0";export{r as productImage};
